type LocalStorageAsPromiseProps<K, V> = {
	key: K;
	expectedValues: Array<V>;
	checkInterval?: number;
};

export const localStorageAsPromise = async <
	K extends string,
	V extends string | null
>({
	key,
	expectedValues,
	checkInterval = 200
}: LocalStorageAsPromiseProps<K, V>): Promise<void> => {
	return new Promise(resolve => {
		let isValueInExpectedArray = expectedValues.includes(
			localStorage.getItem(key) as V
		);

		if (isValueInExpectedArray) {
			resolve();
			return;
		}

		const onCrossTabStorage = (e: StorageEvent) => {
			const isNewValueInExpectedArray = expectedValues.includes(
				e.newValue as V
			);

			if (e.key === key && isNewValueInExpectedArray) {
				cleanup();
				resolve();
			}
		};
		window.addEventListener('storage', onCrossTabStorage);

		// 3️⃣  Same‑tab changes (polling because the storage event
		//     doesn’t fire in the same document that called setItem)
		const id = setInterval(() => {
			isValueInExpectedArray = expectedValues.includes(
				localStorage.getItem(key) as V
			);

			if (isValueInExpectedArray) {
				cleanup();
				resolve();
			}
		}, checkInterval);

		// 4️⃣  Tear‑down helper
		const cleanup = () => {
			clearInterval(id);
			window.removeEventListener('storage', onCrossTabStorage);
		};
	});
};
